import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "card-illustration" };
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = { class: "card-text" };
const _hoisted_4 = { class: "card-label" };
const _hoisted_5 = { class: "card-footer" };
const _hoisted_6 = { class: "card-count" };
const _hoisted_7 = ["src"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'DocCategoryCard',
    props: {
        label: {},
        illustration: {},
        count: {}
    },
    emits: ["click"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "doc-category-card",
                onClick: _cache[0] || (_cache[0] = ($event) => (emit('click')))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("img", {
                        src: _ctx.illustration,
                        alt: _ctx.label,
                        class: "card-illustration-img"
                    }, null, 8, _hoisted_2)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.label), 1),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.count || 'No documents yet'), 1),
                        _createElementVNode("img", {
                            src: require('@/assets/arrow-right.png'),
                            class: "card-arrow"
                        }, null, 8, _hoisted_7)
                    ])
                ])
            ]));
        };
    }
});
